/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Agent } from './Agent.js';
import {
    AgentFromJSON,
    AgentFromJSONTyped,
    AgentToJSON,
} from './Agent.js';

/**
 * 
 * @export
 * @interface ListAgentsResponse
 */
export interface ListAgentsResponse {
    /**
     * 
     * @type {Array<Agent>}
     * @memberof ListAgentsResponse
     */
    data?: Array<Agent>;
    /**
     * 
     * @type {number}
     * @memberof ListAgentsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ListAgentsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ListAgentsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ListAgentsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ListAgentsResponse interface.
 */
export function instanceOfListAgentsResponse(value: object): boolean {
    return true;
}

export function ListAgentsResponseFromJSON(json: any): ListAgentsResponse {
    return ListAgentsResponseFromJSONTyped(json, false);
}

export function ListAgentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAgentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AgentFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ListAgentsResponseToJSON(value?: ListAgentsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AgentToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

